<template>
    <v-dialog
        fullscreen
        hide-overlay
        v-model="opened"
        persistent
        transition="dialog-bottom-transition"
    >
    <v-card tile>
      <v-card-title class="modal__title px-4 pt-4 pb-4">
        <span class="primary--text">
          {{ $t('') }}
        </span>
        <v-spacer />
        <v-btn @click="closeModal" color="primary" icon>
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5 white text-body-1">
        <div class="mw-700 py-5 mx-auto">
            <v-form class="mw-700 py-5 mx-auto" ref="integrationForm" v-model="valid">
                <v-row>
                    <v-col>
                        <HTextInput
                            v-model="integration.api_url"
                            :label="$t('integration.label.apiUrl')"
                            placeholder="Digite o nome"
                            :rules="apiUrlRules"
                        />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-select
                            v-model="integration.external_source"
                            :items="externalSources"
                            item-text="name"
                            item-value="value"
                            :label="$t('integration.label.externalSource')"
                            :rules="required"
                            filled
                        ></v-select>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <HTextInput
                            v-model="integration.key_code"
                            :label="$t('integration.label.keyCode')"
                            :rules="required"
                        />
                    </v-col>
                </v-row>
                <v-row v-if="integration.external_source === 'BROGNOLI'">
                    <v-col>
                        <HTextInput
                            v-model="integration.api_user"
                            :label="$t('integration.label.apiUser')"
                            :rules="required"
                        />
                    </v-col>
                </v-row>

                <v-row v-if="integration.external_source === 'VISTA'">
                    <v-col>
                        <v-switch
                            v-model="integration.push_enabled"
                            :label="$t('integration.label.pushEnabled')"
                            :hint="$t('integration.hint.pushEnabled')"
                            :ripple="false"
                            persistent-hint
                            inset
                        />

                        <span
                            v-if="integration.push_enabled"
                            class="d-flex align-start body-2 mt-4 warning--text"
                        >
                            <v-icon color="warning lighten-1" left>
                                mdi-alert-circle-outline
                            </v-icon>
                            {{ $t('integration.warnings.pushEnabled') }}
                        </span>
                    </v-col>
                </v-row>

                <div class="d-flex justify-end mt-15">
                    <v-btn
                        elevation="0"
                        color="primary"
                        :disabled="!valid"
                        @click="update"
                        :loading="isLoading"
                        large
                    >
                        {{ $t('create.save') }}
                    </v-btn>
                </div>
            </v-form>
        </div>
      </v-card-text>
    </v-card>
    </v-dialog>
</template>
<script>
import HTextInput from '@/components/app/HTextInput'
import { mapGetters, mapActions } from 'vuex'
export default {
    name:"MissionUpdate",
    data() {
        return {
            opened: false,
            valid: false,
            required: [(v) => (!!v && v.trim() != '') || this.$t('rules.required')],
            apiUrlRules: [
                v => !!v || this.$t('integration.rules.required'),
                v => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,10}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)*\/$/.test(v)
                || this.$t('integration.rules.apiUrl')
            ],
            externalSources: [
                {
                    name: this.$t("integration.externalSources.VISTA"),
                    value: "VISTA"
                },
                {
                    name: this.$t("integration.externalSources.BROGNOLI"),
                    value: "BROGNOLI"
                },
            ],
        }
    },
    components: {
        HTextInput
    },
    watch: {
        integration: {
            handler(newVal, oldVal){ 
                if (newVal.external_source != 'BROGNOLI') {
                    this.integration.api_user = null
                }
                if (newVal.external_source != 'VISTA') {
                    this.integration.push_enabled = false
                }
            },
            deep: true,
        }
    },
    computed: {
        ...mapGetters(['integration', 'isLoading']),
    },
    methods: {
        ...mapActions(['updateIntegration', 'fetchIntegration']),

        async update() {
            this.updateIntegration(this.buildUpdateIntegrationBody())
            this.closeModal()
        },

        async openModal(integrationId) {
            this.opened = true
            await this.fetchIntegration(integrationId)

            // integrações antigas não trazem o campo, e sem $set o switch não fica reativo
            if (this.integration.push_enabled === undefined) {
                this.$set(this.integration, 'push_enabled', false)
            }
        },

        resetForm() {
            this.$refs.integrationForm.reset()
        },

        closeModal() {
            this.resetForm()
            this.opened = false
        },
        
        buildUpdateIntegrationBody() {
            return {
                id: this.integration.id,
                external_source: this.integration.external_source,
                api_url: this.integration.api_url,
                key_code: this.integration.key_code,
                api_user: this.integration.api_user,
                push_enabled: this.integration.push_enabled ?? false,
                enabled: true,
            }
        }
    },
}
</script>
